import { AppBar, Box, Button, Container, Toolbar } from '@mui/material';
import { Link, Navigate, Route, Routes } from 'react-router-dom';
import { NotesPage, NoteViewPage } from './features/notes';
import { WeeklyWeights, Weights } from './features/weight-progress';

const routes = [
  {
    to: '/weights',
    title: 'Weights',
    component: <Weights />,
  },
  {
    to: '/weights/weekly',
    title: 'Weekly Weights',
    component: <WeeklyWeights />,
  },
  {
    to: '/notes',
    title: 'Notes',
    component: <NotesPage />,
  },
];

function App() {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'whitesmoke' }}>
      <AppBar position="static" variant="outlined" elevation={0}>
        <Toolbar variant="dense" sx={{ justifyContent: 'space-evenly' }}>
          {routes.map(({ to, title }) => (
            <Link key={to} to={to} style={{ textDecoration: 'none' }}>
              <Button variant="text" sx={{ color: 'white' }}>
                {title}
              </Button>
            </Link>
          ))}
        </Toolbar>
      </AppBar>

      <Container sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
        <Routes>
          {routes.map(({ to, component }) => (
            <Route key={to} path={to} element={component} />
          ))}
          <Route path="/notes/:id" element={<NoteViewPage />} />
          <Route path="*" element={<Navigate to={routes[2].to} replace />} />
        </Routes>
      </Container>
    </Box>
  );
}

export default App;
